import React, { ReactElement, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import MyAccountLayout from 'components/MyAccount/MyAccountLayout';
import SidebarNavigation from 'components/MyAccount/SidebarNavigation';
import useAsyncEffect from 'hooks/useAsyncEffect';
import WelcomeSurveyModal from 'components/shared/modals/WelcomeSurveyModal';
import Footer from '../components/footer/Footer';
import { LoggedInHeader } from '../components/header/LoggedInHeader';
import { LoggedOutHeader } from '../components/header/LoggedOutHeader';
import { useAuth } from '../contexts/AuthContext';
import styles from './Layout.module.scss';
import { CookieModal } from '../components/shared/modal/CookieModal';
import { Route } from '../utils/config';

type Props = {
  withCart?: boolean;
  withAccountLayout?: boolean;
  isPDP?: boolean;
  isWide?: boolean;
}

function Layout({
  withCart = false,
  withAccountLayout = false,
  isPDP = false,
  isWide = false,
}: Props): ReactElement {
  const { isLoggedIn } = useAuth();
  const { pathname } = useLocation();
  const isCookieBannerEnabled = window.gon?.featureFlags?.isCookieBannerEnabled;

  const [showWelcomeSurveyModal, setShowWelcomeSurveyModal] = useState(false);
  useAsyncEffect(async (isMounted) => {
    setTimeout(() => {
      if (isMounted.current) {
        const showWelcomeSurvey = localStorage.getItem('showWelcomeSurvey');
        setShowWelcomeSurveyModal(
          pathname === Route.HUB
          && !!showWelcomeSurvey
          && new Date(showWelcomeSurvey) <= new Date(),
        );
      }
    }, 2000);
  }, [pathname]);

  return (
    <div className={styles.body}>
      <a className="sr-only sr-only-focusable" href="#content">
        Skip to main content
      </a>

      {isLoggedIn
        ? <LoggedInHeader withCart={withCart} isPDP={isPDP} />
        : <LoggedOutHeader withCart={withCart} />}

      <main id="content" aria-label="Main content">
        <div className={styles.main_content}>
          {isLoggedIn && withAccountLayout ? (
            <div className={styles.my_account_main_content}>
              <div className="d-none d-lg-block c-my-account__sidebar">
                <SidebarNavigation />
              </div>
              <MyAccountLayout />
            </div>
          ) : (
            <div
              className={`${styles.without_account_content} ${withCart && isPDP || isWide ? '' : styles.max_width_centered}`}
            >
              <Outlet />
            </div>
          )}
        </div>
      </main>

      {isLoggedIn && showWelcomeSurveyModal && (
        <WelcomeSurveyModal onClose={() => setShowWelcomeSurveyModal(false)} />
      )}

      <Footer />
      {isCookieBannerEnabled && <CookieModal />}
    </div>
  );
}

export default Layout;
